module.exports = __webpack_public_path__ + "img/3d-cube-scan.44cb1351.svg";